<template>
  <div class="tile is-ancestor footer-padding">


    <div class="tile is-parent is-vertical is-12">
      <div class="tile">
        <div class="tile is-6">
          <Tile title="STCW95 Training" subtitle="Have you completed STCW95 Training?">
            <b-field horizontal label="STCW95 Training expiry" class="long-label">
              <b-datepicker
                placeholder="Leave blank if not applicable"
                :value="stcw95TrainingExpiry && new Date(stcw95TrainingExpiry)"
                @input="(d) => stcw95TrainingExpiry = d && $moment(d).format('YYYY-MM-DD')"
                icon="calendar-today"/>
            </b-field>
            <b-field horizontal label="Clear" class="long-label">
              <button @click="stcw95TrainingExpiry=null" class="button is-danger">
                <b-icon icon="close"/>
              </button>
            </b-field>
          </Tile>
        </div>
        <div class="tile is-6">
          <Tile title="ENG 1 Medical Certificate"
            subtitle="Do you have an ENG 1 Medical Certificate?">
            <b-field horizontal label="ENG 1 Medical Certificate expiry" class="long-label">
              <b-datepicker
                placeholder="Leave blank if not applicable"
                :value="eng1MedicalCertificateExpiry && new Date(eng1MedicalCertificateExpiry)"
                @input="(d) => eng1MedicalCertificateExpiry = d && $moment(d).format('YYYY-MM-DD')"
                icon="calendar-today"/>
            </b-field>
            <b-field horizontal label="Clear" class="long-label">
              <button @click="stcw95TrainingExpiry=null" class="button is-danger">
                <b-icon icon="close"/>
              </button>
            </b-field>

          </Tile>
        </div>
      </div>

      <section v-if="!edittedCertificates.length" class="hero is-primary tile">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">
              No Certificates
            </h1>
            <h2 class="subtitle">
              Click on add certificate below to add your first one!
            </h2>
          </div>
        </div>
      </section>

      <Tile v-for="(certificate, index) in edittedCertificates"
        :key="certificate.id" :title="`Certificate ${index + 1}`">
        <b-field horizontal label="Title">
          <b-input v-model="certificate.title"/>
        </b-field>
        <b-field horizontal label="Date Issued">
          <b-datepicker :value="certificate.issued_date && new Date(certificate.issued_date)"
              @input="(d) => certificate.issued_date = $moment(d).format('YYYY-MM-DD')"
              icon="calendar-today"/>
        </b-field>

        <b-field horizontal label="Issued By">
          <b-input v-model="certificate.issued_by" />
        </b-field>
        <b-field horizontal label="File (pdf, docx, jpeg, jpg, png)">
          <b-upload @input="(f) => $set(certificate, 'tempFile', f)"
            accept=".docx, .pdf, .jpeg, .jpg, .png">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Click to upload</span>
            </a>
          </b-upload>
          <span v-if="certificate.tempFile" class="label">
            New file: <em>{{certificate.tempFile.name}}</em>
          </span>
          <div>
            <a v-if="certificate.file" :href="certificate.file.file" target="_blank">
              See your existing File
            </a>
          </div>
        </b-field>

        <b-field horizontal label="Remove">
          <button class="button is-small is-danger"
            @click="edittedCertificates = edittedCertificates.filter((_, i) => i !== index)">
            <b-icon icon="close"/>
          </button>
        </b-field>
      </Tile>
    </div>

    <Footer>

      <button @click="addCertificate"
        class="button is-medium is-primary has-margin-right"
        :disabled="!canAdd">
        Add new certificate
      </button>

      <button :class="[
        'button', 'is-medium',
        'is-primary', loading && 'is-loading']"
        :disabled="!hasChanges"
        @click="save">
        Save
      </button>
    </Footer>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import Tile from '@/components/Tile';
import Footer from '@/components/Footer';


export default {
  components: {
    Tile,
    Footer,
  },
  data() {
    return {
      edittedCertificates: [],
      loading: false,
      stcw95TrainingExpiry: null,
      eng1MedicalCertificateExpiry: null,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.auth.user.profile,
    }),
    hasChanges() {
      return this.stcw95TrainingExpiry !== this.profile.stcw95_training_expiry
            || this.eng1MedicalCertificateExpiry !== this.profile.eng_1_medical_certificate_expiry
            || !isEqual(this.profile.certificates, this.edittedCertificates);
    },
    canAdd() {
      return !this.edittedCertificates.find(c => !c.id);
    },
  },
  methods: {
    ...mapActions({
      updateProfile: 'auth/updateProfile',
    }),
    saveFiles() {
      const promises = this.edittedCertificates.filter(c => c.tempFile).map((c) => {
        const data = new FormData();
        data.append('category', 'certificate');
        data.append('file', c.tempFile);
        return this.$http.post('files/', data, { 'Content-Type': 'multipart/form-data' }).then((resp) => {
          c.tempFile = resp.data;
        });
      });
      return Promise.all(promises);
    },
    async save() {
      this.loading = true;

      try {
        await this.saveFiles();
      } catch (e) {
        this.$toast.open({
          message: 'Could not save the new file',
          type: 'is-danger',
        });
        this.tempFile = null;
        this.loading = false;
        return;
      }


      try {
        await this.updateProfile({
          id: this.profile.id,
          certificates: this.edittedCertificates.map(c => ({
            ...c,
            file: c.tempFile ? c.tempFile.id : c.file && c.file.id,
            tempFile: undefined,
          })),
          stcw95_training_expiry: this.stcw95TrainingExpiry,
          eng_1_medical_certificate_expiry: this.eng1MedicalCertificateExpiry,
        });
      } catch (e) {
        this.$toast.open({
          message: 'Could not save the certificates info',
          type: 'is-danger',
        });
        return;
      } finally {
        this.loading = false;
      }
      this.initialize();
    },
    addCertificate() {
      this.edittedCertificates.push({
        title: null,
        issued_date: null,
        issued_by: null,
        file: null,
        tempFile: null,
      });
    },
    initialize() {
      this.edittedCertificates = cloneDeep(this.profile.certificates);
      this.stcw95TrainingExpiry = this.profile.stcw95_training_expiry;
      this.eng1MedicalCertificateExpiry = this.profile.eng_1_medical_certificate_expiry;
    },
  },
  created() {
    this.initialize();
  },
};
</script>


<style lang="scss" scoped>
.long-label {
  /deep/ .field-label {
    flex-grow: 5
  }
}
</style>
